module.exports = __webpack_public_path__ + "media/images/result_sets/icons/enneagram_icon-7923a37212d847d6d0e21f9575cf9e0a.svg";